import DialogBox from "./dialog";

export default DialogBox;
